import Moment from "moment";

const EDIT_SUBSCRIPTION_SYSTEM_FORM = {
  submit: {
    label: 'edit_system_subscription.submit_btn'
  },
  fields: [
    {
      name: 'subscription',
      label: 'edit_system_subscription.subscription_field',
      type: 'select',
      items: [],
      validators: ['requiredSubscription'],
      errors: ['errors.required_subscription'],
      defaultValue: ''
    },
    {
      name: 'billingPeriod',
      label: 'edit_system_subscription.billing_period_field',
      type: 'select',
      items: [
        {label: 'subscription_billing_period.NONE', value: 'NONE', translate: true},
        {label: 'subscription_billing_period.MONTHLY', value: 'MONTHLY', translate: true},
        {label: 'subscription_billing_period.ANNUAL', value: 'ANNUAL', translate: true}
      ],
      validators: ['required'],
      errors: ['errors.required_billing_period'],
      defaultValue: ''
    },
    {
      name: 'price',
      type: 'grid',
      fields: [
        {
          name: 'pricePerBike',
          label: 'edit_system_subscription.price_per_bike_field',
          type: 'text',
          validators: [
            'required',
            'matchRegexp:^[0-9]{1,100}$',
            'minNumber:0',
            'maxNumber:999999999'
          ],
          errors: [
            'errors.required_number',
            'errors.invalid_number_format',
            'errors.min_price_per_bike_error',
            'errors.max_price_per_bike_error'
          ],
          defaultValue: ''
        },
        {
          name: 'currency',
          label: 'edit_system_subscription.currency_field',
          type: 'select',
          items: [
            {label: 'currency.usd', value: 'USD', translate: true},
            {label: 'currency.cad', value: 'CAD', translate: true}
          ],
          validators: ['required'],
          errors: ['errors.required_currency'],
          defaultValue: 'USD'
        },
      ]
    },
    {
      name: 'autoCancellation',
      label: 'edit_system_subscription.auto_cancellation_field',
      type: 'text',
      validators: [
        'required',
        'matchRegexp:^[0-9]{1,1000}$',
        'minNumber:0',
        'maxNumber:1000'
      ],
      errors: [
        'errors.required_capacity',
        'errors.invalid_number_format',
        'errors.min_auto_cancellation_error',
        'errors.max_auto_cancellation_error'
      ],
      defaultValue: ''
    },
    {
      name: 'nextBillingPeriod',
      label: 'edit_system_subscription.next_billing_period_field',
      type: 'date',
      validators: [],
      errors: [],
      defaultValue: Moment(new Date()).format('yyyy MM DD')
    },
  ]
}

export default EDIT_SUBSCRIPTION_SYSTEM_FORM;
